import React from 'react';
import Routing from '@Routing/components/Routing';
import useSetPageLayout from "@Hooks/dispatch/useSetPageLayout";
import useHandleAppErrors from "@Features/errors/hooks/useHandleAppErrors";
import useLoginListener from "@User/hooks/useLoginListener";
import setDefaultCurrencyIfNoneSet from "@Currency/functions/setDefaultCurrencyIfNoneSet"

export default function App() {
    useLoginListener()
    useSetPageLayout()
    setDefaultCurrencyIfNoneSet()
    useHandleAppErrors()

    return (
        <Routing/>
    );
}
